import React, { createContext, useState } from 'react';

export const FLOW_HINTS = {
  variableHintDone: false,
  operatorHintDone: false,
  blockHintDone: false,
};

export const BusinessLogic = createContext();

const BusinessLogicProvider = ({ children }) => {
  const [currentBusinessLogic, setCurrentBusinessLogic] = useState(undefined);
  const [businessLogics, setBusinessLogics] = useState([]);
  const [flowHints, setFlowHints] = useState(FLOW_HINTS);
  const [isAddBusinessLogic, setAddBusinessLogic] = useState(false);
  const [deletedRules, setDeletedRules] = useState({});

  const contextValue = {
    currentBusinessLogic,
    businessLogics,
    flowHints,
    isAddBusinessLogic,
    deletedRules,
    setCurrentBusinessLogic,
    setBusinessLogics,
    setFlowHints,
    setAddBusinessLogic,
    setDeletedRules
  };

  return <BusinessLogic.Provider value={contextValue}>{children}</BusinessLogic.Provider>;
};

export default BusinessLogicProvider;
